import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
//import { Angular2CsvModule } from 'angular2-csv/Angular2-csv';
import { ngxCsv } from 'ngx-csv/ngx-csv';
//import { Angular2Csv } from 'angular2-csv';
@Component({
    selector: 'app-dashboard',
    templateUrl: './payment.component.html',
    providers: [ SharedService,PopupSegmentComponent]
    // styleUrls: ['./dashboard.component.scss']

})
export class PaymentComponent implements OnInit {

itemsTotalAdv : number =0;
  countryArray: any = [];
  country :number =13;
  objLoaderStatus: boolean = false;
  id : number;
  data : any =[];
  page : number =1;
  editFlag = [];
  message ="";
  downloadExcelData:any=[];

  enable = [];
  enableFlag = false;

  errormessage = "";
  errorUpdate =[];

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {
    

    
    }

    ngOnInit() {
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

    var token = this.localstorage.getStorage("token");
              this.loaderService.displayLoader(true);
 this.shareService.CallDatawithToken("master/countries", null, token).subscribe((result) => {
        this.countryArray = result.data;
        if(this.localstorage.getStorage("country") !== "" && this.localstorage.getStorage("country") !== null){
        this.country = this.localstorage.getStorage("country");
      }
      else{
        this.country  = 13;
      }
        this.getState(this.country);
                 this.loaderService.displayLoader(false);

      });


    }

   getState(event){
     this.itemsTotalAdv =0;
     this.country = event;
       var token = this.localstorage.getStorage("token");
                 this.loaderService.displayLoader(true);
      this.localstorage.setStorage("country",this.country);
      this.shareService.CallDatawithToken("admin/getAllStatesPrice?currentSize=25&CountryId="+event, null, token).subscribe((result) => {
        if(result.data){
          this.dataShowChange(result.data)
        this.data = result.data;
            this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
                      this.loaderService.displayLoader(false);

        }
      });
   }

   changeFlag(id){
  this.id = id;
  console.log(this.data);
  var i=0;
  for(i=0;i<this.data.length;i++){
    this.editFlag[this.data[i].id] = false;
    console.log(this.data[i].id == id);
if(this.data[i].id == id){
this.editFlag[id] = true;
}
}
}

onChange(event,id){
      var token = this.localstorage.getStorage("token");
    if(event == true){
      this.loaderService.displayLoader(true);
      this.shareService.callApiWithToken("admin/updateStatePrice?price=1&isPaid=1&id="+id,{},token).subscribe((result) => {
        if(result.data && result.data.status == true){
          // this.showblock();    
          this.enable[id] = true;
          event = true;
          this.loaderService.displayLoader(false);
        }
        this.loaderService.displayLoader(false);
      });
    }
    else{
      this.loaderService.displayLoader(true);
      this.shareService.callApiWithToken("admin/updateStatePrice?price=1&isPaid=1&id=="+id,{},token).subscribe((result) => {
        if(result.data && result.data.status == true){
        // this.showunblock();     
        this.enable[id] = false;
        event = false;
        this.loaderService.displayLoader(false);

        }
        this.loaderService.displayLoader(false);
      });

    }

}

dataShowChange(data){
    var i=0
    for(i=0;i<data.length;i++){
      if(data[i].isPaid == 1){
        this.enable[data[i].id]= true;
      }
      else{
        this.enable[data[i].id]= false;
      }
    }


    this.data = data;

}

nextPrice(event){
this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
    this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllStatesPrice?currentSize=25&CountryId="+this.country+"&currentPage="+event, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    this.loaderService.displayLoader(false);

}
  
         });
  
    return event; 
    
        
}


  showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Base Price State Information', 
                message:this.message,
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 
                });
        }

        excelDownload(){
          var j=0;
          var countryName = "";
          for(j=0;j<this.countryArray.length;j++){
            if(this.countryArray[j].id == this.country){
countryName = this.countryArray[j].name;
            }
          }
      var data = [];
      data[0]={
        'Country Name':'Country Name',
        'State Name':'State Name',
        'Price (in $ AUD)':'Price (in $ AUD)',
      };
      var i:any=1;
 this.downloadExcelData.forEach((value,key) => {

            var excelData={}; 
           excelData['Country Name']=countryName;
            excelData['State Name']=value.name;
            excelData['Price (in $ AUD)']=value.price;
           
            data.push(excelData);
            i++;
      });

      this.downloadExcelData=[];
     // new Angular2Csv(data, 'BaseStatePrice');
     var options={};
     new ngxCsv(data, 'BaseStatePrice', options);
             this.loaderService.displayLoader(false);

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/payment/payment.component.ts